import { Divider, Space } from 'antd'
import { createStyles } from 'antd-style'

import { CrudFormFooterProps } from './interface'

const useCrudFormFooterStyles = createStyles(({ token }) => ({
  footer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: token.paddingMD
  }
}))

export const CrudFormFooter = ({
  className,
  style,
  actions,
  moreActions: externalMoreActions
}: CrudFormFooterProps) => {
  const moreActions = externalMoreActions
    ? [
        <Divider
          key='actionDivider'
          orientation='vertical'
          titlePlacement='center'
          styles={{
            content: {
              margin: 24
            }
          }}
        />,
        ...externalMoreActions
      ]
    : undefined

  const { cx, styles } = useCrudFormFooterStyles()

  return (
    <div className={cx(styles.footer, className)} style={style}>
      <Space size='large'>
        {actions}
        {moreActions}
      </Space>
    </div>
  )
}
